module.exports = __webpack_public_path__ + "static/media/7.e9951b9b.jpg";